import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useGame } from "@/context/GameContext";

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { setPaywallOpen } = useGame();
  return (
    <div className="min-h-screen flex items-center justify-center px-4 dotted-bg" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-white rounded-3xl border-4 border-slate-300 p-8 text-center card-3d">
        <div className="text-6xl mb-3">🐕</div>
        <h1 className="font-display text-3xl font-bold text-slate-900">No worries!</h1>
        <p className="text-slate-600 font-medium mt-2">Nothing was charged. Dog Walker is still free to play any time.</p>
        <div className="mt-6 grid gap-2">
          <Button onClick={() => { navigate("/"); setPaywallOpen(true); }} data-testid="payment-retry-btn" className="bg-emerald-500 hover:bg-emerald-600 text-white font-heading font-black rounded-2xl btn-3d border-2 border-emerald-600 py-6">
            Try unlocking again
          </Button>
          <Button onClick={() => navigate("/")} data-testid="payment-cancel-back-btn" variant="outline" className="font-heading font-black rounded-2xl border-2 py-6">
            Back to the Hub
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
